import React, { useState, useEffect, useRef, useContext } from "react";
import { debounce } from "throttle-debounce";
import { compose } from "redux";
import classNames from "classnames";

import DraggingContext from "fantastic/lib/DraggingContext";
import styles from "fantastic/components/hoc/styles";
import connectActions from "fantastic/lib/connectActions";
import utils from "fantastic/lib/utils";
import actions from "fantastic/actions";

import Tools from './image/Tools';

const Image = props => {
  const {
    id,
    src,
    width,
    fixed_width = false,
    dimension,
    natural_height,
    natural_width,
    href,
    alt,
    text_align,
    style,
    update,
    uploadImage,
    preview,
    mobile,
    css_padding_left,
    css_padding_right,
    css_padding_top,
    css_padding_bottom,
    css_border_radius,
    mobile_autosize
  } = props;
  
  // const isBeta = () => {
  //   if(preview) return false;
  //
  //   const { betaMode } = useContext(DraggingContext);
  //
  //   return betaMode;
  // }

  const defaultImageAttributes = {
    text_align: "left"
  };

  const applySelectedImage = image => {
    let attrs = { src: image.url, ...defaultImageAttributes };
    if (!alt || alt.length === 0) attrs.alt = image.name || '';
    update(id, attrs);
  };

  const openWarehouse = event => {
    event.preventDefault();
    warehouseLoader.show(applySelectedImage);
  };

  const openWarehouseWithGeneration = event => {
    event.preventDefault();
    warehouseLoader.show(applySelectedImage, 'generation');
  };

  const [collapse, setCollapse] = useState(!preview);

  useEffect(() => {
    const timer = setTimeout(() => {
      setCollapse(preview);
    }, 10);
    return () => clearTimeout(timer);
  }, [preview]);

  const uploadClasses = classNames("fantastic-upload-image", {
    "fantastic-upload-image--collapse": collapse && preview
  });

  const fileChangedHandler = event => {
    uploadImage(id, event.target.files[0], defaultImageAttributes);
  };
  const fileInput = useRef(null);
  const triggerUploadFile = () => {
    event.preventDefault();
    fileInput.current.click();
  };

  const image = useRef({});

  const setImageDimension = (img, width, dimension) => {

    if (preview || !img) return;
    const newWidth = Math.floor(img.width);
    const newHeight = (img.naturalHeight * newWidth) / img.naturalWidth;

    const attrs = {
      natural_width: img.naturalWidth,
      natural_height: img.naturalHeight,
      width: newWidth,
      dimension: [newWidth, newHeight]
    };

    if (width && dimension && dimension[0] === newWidth && dimension[1] === newHeight) return;
    if (isNaN(newWidth) || isNaN(newHeight)) return;

    update(id, attrs);
  };

  const debouncedSetImageDimension = useRef(debounce(1000, setImageDimension))
    .current;

  function pxBorderRadius(val) {
    if (!val) return '';
    return val
      .split(' ')
      .map(v => v.trim())
      .filter(v => v !== '')
      .map(v => `${v}px`)
      .join(' ');
  }

  const setImageInlineStyles = img => {

    if (img && Object.keys(img).length) {
      img.style.setProperty('border-radius', pxBorderRadius(css_border_radius));
    }

    if (!img || Object.keys(img).length == 0 || (preview && mobile && mobile_autosize)) return;
    if (fixed_width)
      img.style.setProperty('width', utils.px(width),  "important");
    else
      img.style.removeProperty('width');
  };
  useEffect(() => {
    debouncedSetImageDimension(image.current, width, dimension);
    setImageInlineStyles(image.current);
  }, [
    href,
    width,
    fixed_width,
    css_padding_left,
    css_padding_right,
    css_padding_top,
    css_padding_bottom,
    css_border_radius,
    src
  ]);

  const wrapImage = imgTag => {
    if (href)
      return (
        <a align="center" onClick={e => e.preventDefault()} href={href}>
          {imgTag}
        </a>
      );

    return <div align="center">{imgTag}</div>;
  };

  if (src) {
    return (
      <div className="fantastic-item__image" style={style}>
        {props.meta.selected && <Tools url={src} onChange={applySelectedImage} />}
        {wrapImage(
          <img
            ref={image}
            src={src}
            alt={alt}
            width={width}
            className={text_align}
            onLoad={e => debouncedSetImageDimension(e.target)}
          />
        )}
        <div className="clearfix" />
      </div>
    );
  }

  if (preview && mobile) {
    return null;
  }

  return (
    <div className={uploadClasses}>
      <div className="fantastic-upload-image__container">
        <a
          className="fantastic-upload-image__container--icon"
          href="#"
          onClick={openWarehouse}
        >
          <i className="fa fa-cloud" />
        </a>
        <a
          className="fantastic-upload-image__container--text"
          href="#"
          onClick={openWarehouse}
        >
          { i18n.t('file_select') }
        </a>
      </div>
      <div className="fantastic-upload-image__container">
        <a
          className="fantastic-upload-image__container--icon"
          href="#"
          onClick={openWarehouseWithGeneration}
        >
          <i className="fi fi-sparkles" />
        </a>
        <a
          className="fantastic-upload-image__container--text"
          href="#"
          onClick={openWarehouseWithGeneration}
        >
          { i18n.t('generate_image') }
        </a>
      </div>
      <div className="fantastic-upload-image__container">
        <a
          className="fantastic-upload-image__container--icon"
          onClick={triggerUploadFile}
          href="#"
        >
          <i className="fa fa-download" />
        </a>
        <a
          className="fantastic-upload-image__container--text"
          onClick={triggerUploadFile}
          href="#"
        >
          { i18n.t('file_upload') }
        </a>
      </div>
      <input
        type="file"
        style={{ display: "none" }}
        accept="image/jpeg,image/png,image/gif"
        onChange={fileChangedHandler}
        ref={fileInput}
      />
    </div>
  );
};

export default compose(
  connectActions({
    update: actions.updateNode,
    uploadImage: actions.uploadImage
  }),
  styles("padding", "border")
)(Image);
